import { useEffect, useState } from "react";
import CommonGrid from "../../components/CommonGrid";
import {
  gridColumns_DefaultManagement31DaysPast,
  gridColumns_DefaultManagementCommon,
} from "../../Utils/TableColumnDefs";
import { useSelector } from "react-redux";
import QuickInfoCardCommon from "../../components/QuickInfoCardCommon";
import {
  fetchLoans31DaysPastDue,
  fetchLenderLoans,
  fetchDefaultManagementData,
} from "./lonaServiceApi";
import { useAbortController } from "../../hooks/useAbortController";
import { roleType } from "../../Utils/constant";

const DMTableSection = () => {
  const { signal } = useAbortController();
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const lenderId = useSelector((state) => state.account.lenderId);
  const [loanData, setLoanData] = useState({
    days31PastDue: [],
    loansInForeclosure: [],
    loansInWorkout: [],
    loansInBankruptcy: [],
  });
  const [loading, setLoading] = useState({
    days31PastDue: true,
    foreclosure: true,
    workout: true,
    bankruptcy: true,
  });
  
  const isBroker = selectedRole === roleType.broker ? 1 : 0;

  useEffect(() => {
    setLoading((data) => ({
      ...data,
      loansInForeclosure: true,
      loansInWorkout: true,
      loansInBankruptcy: true,
    }));
    fetchLenderLoans({ lenderId, signal, isBroker }).then((data) => {
      if (data?.loansInForeclosure) {
        setLoanData((data2) => ({
          days31PastDue: data2.days31PastDue,
          loansInForeclosure: data.loansInForeclosure,
          loansInWorkout: data.loansInWorkout,
          loansInBankruptcy: data.loansInBankruptcy,
        }));
        setLoading((data) => ({
          ...data,
          loansInForeclosure: false,
          loansInWorkout: false,
          loansInBankruptcy: false,
        }));
      } else {
        setLoading((data) => ({
          ...data,
          loansInForeclosure: false,
          loansInWorkout: false,
          loansInBankruptcy: false,
        }));
      }
    });
  }, [lenderId]);

  useEffect(() => {
    setLoading((data) => ({ ...data, days31PastDue: true }));
    fetchLoans31DaysPastDue({ lenderId, signal, isBroker })
      .then((finalData) => {
        setLoanData((data) => ({ ...data, days31PastDue: finalData }));
        setLoading((data) => ({ ...data, days31PastDue: false }));
      })
      .catch((error) => {
        console.error("Error fetching 31+ days past due loans:", error);
        setLoading((data) => ({ ...data, days31PastDue: false }));
      });
  }, [lenderId]);

  const calculatePrincipalBalanceSum = (data) => {
    return data.reduce(
      (sum, loan) => sum + (loan["Principal Balance"] || "-"),
      0
    );
  };

  const principalBalanceSum = calculatePrincipalBalanceSum(
    loanData.days31PastDue
  );

  const renderGrid = (key, title, columns) => {
    return (
      <CommonGrid
        className={`${key} col-sm-6`}
        title={title}
        gridColumns={columns}
        columnData={loanData[key]}
        status={loading[key] === false ? "fulfilled" : "idle"}
      />
    );
  };

  return (
    <article className="container-fluid">
      <section className="row">
        <div className="mb-5">
          <div
            className="col-xl-12 col-lg-12 portfolio-balance-upcoming-payments d-flex flex-column"
            style={{ minHeight: "150px" }}
          >
            <div className="row flex-1">
              <button className="col-xl-6 col-lg-6" style={{ border: "none" }}>
                <QuickInfoCardCommon
                  class_name="h-100 bg-white rounded"
                  label={"Default Portfolio Balance"}
                  info={principalBalanceSum}
                />
              </button>
              <div className="col-xl-6 col-lg-6">
                <QuickInfoCardCommon
                  label="Total No. of Defaults"
                  info={
                    loanData.days31PastDue ? loanData.days31PastDue.length : "-"
                  }
                  class_name={"h-100"}
                />
              </div>
            </div>
          </div>
        </div>
        {renderGrid(
          "days31PastDue",
          "31+ Days Past Due Defaults",
          gridColumns_DefaultManagement31DaysPast
        )}
        {renderGrid(
          "loansInForeclosure",
          "Loans in Foreclosure",
          gridColumns_DefaultManagementCommon
        )}
        {renderGrid(
          "loansInWorkout",
          "Loans in Workout",
          gridColumns_DefaultManagementCommon
        )}
        {renderGrid(
          "loansInBankruptcy",
          "Loan in bankruptcy",
          gridColumns_DefaultManagementCommon
        )}
      </section>
    </article>
  );
};

export default DMTableSection;
